/*
 *             Copyright (c) 2016 - 2022, CKSource Holding sp. z o.o. All rights reserved.
 *
 *
 *
 *
 *          +---------------------------------------------------------------------------------+
 *          |                                                                                 |
 *          |                                 Hello stranger!                                 |
 *          |                                                                                 |
 *          |                                                                                 |
 *          |   What you're currently looking at is the source code of a legally protected,   |
 *          |    proprietary software. Any attempts to deobfuscate / disassemble this code    |
 *          |               are forbidden and will result in legal consequences.              |
 *          |                                                                                 |
 *          |                                                                                 |
 *          +---------------------------------------------------------------------------------+
 *
 *
 *
 *
 */
var _0x5124=['uint32','description','Position'];(function(_0xfcc35e,_0x512458){var _0x2e6683=function(_0x89649d){while(--_0x89649d){_0xfcc35e['push'](_0xfcc35e['shift']());}};_0x2e6683(++_0x512458);}(_0x5124,0xa6));var _0x2e66=function(_0xfcc35e,_0x512458){_0xfcc35e=_0xfcc35e-0x0;var _0x2e6683=_0x5124[_0xfcc35e];return _0x2e6683;};import _0x15db88 from'./operationcompressor';export default class m extends _0x15db88{static get[_0x2e66('0x0')](){return{'fields':{'sourcePosition':{'type':_0x2e66('0x1'),'id':0x1},'howMany':{'type':_0x2e66('0x2'),'id':0x2},'targetPosition':{'type':_0x2e66('0x1'),'id':0x3},'wasUndone':{'type':'bool','id':0x4}}};}}